import { createFileRoute } from '@tanstack/react-router'

import { ItemCategoryFormPage } from '@/features/inventory/components/item-category-form-page'

export const Route = createFileRoute('/_app/inventory/category/create')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ItemCategoryFormPage mode='create' />
}
